import { createContext, useContext, useMemo, useState } from 'react';

interface AgentChatContextValue {
    isOpen: boolean;
    open: () => void;
    close: () => void;
}

const AgentChatContext = createContext<AgentChatContextValue | null>(null);

export function AgentChatProvider({ children }: { children: React.ReactNode }) {
    const [isOpen, setIsOpen] = useState(false);
    const value = useMemo<AgentChatContextValue>(
        () => ({
            isOpen,
            open: () => setIsOpen(true),
            close: () => setIsOpen(false),
        }),
        [isOpen]
    );
    return (
        <AgentChatContext.Provider value={value}>
            {children}
        </AgentChatContext.Provider>
    );
}

export function useAgentChat(): AgentChatContextValue {
    const ctx = useContext(AgentChatContext);
    if (!ctx) {
        throw new Error(
            'useAgentChat must be used within an AgentChatProvider.'
        );
    }
    return ctx;
}
